import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import SearchBar from './search-bar';
import { useEffect } from 'react';

import StatisticsCounter from '../components/statistics-counter';

export default function Home() {

  //first thing done: update page title
  useEffect(() => {
    document.title = 'Vista Enhancer Browser'; 
}, []);

  return (

    
    <main style={{ padding: "3rem 0" }}>
    <Container>
    
      <br/>
    <h5 className="justify-content-md-center" >
          The VISTA Enhancer Browser is a central resource for human and mouse transcriptional enhancers that have been validated in vivo in transgenic mouse embryos.</h5>
      <br/>
      <div>
        <Container style={{display:''}} className='text-center'>
            <SearchBar />
        </Container>
      </div>
      <br/>
      <div className='text-center'>
      <h1 className='text-center'>Enhancer Discovery For</h1>
    <img src="images/homepage.png" style={{width:"75%"}} className=" mx-3 my-5" alt=""></img>
    </div>
    
      
      <Row className="justify-content-md-center">
            <div className="mx-3" style={{fontSize:"18px"}}>
        <p>
            This program is located at the <a href="http://www.lbl.gov" target="_blank" rel="noreferrer">Lawrence Berkeley National Laboratory</a>. See the <a href='manual'>Manual</a> for additional details on this work or visit the <a href="browse">Browse Page</a> to view data. We invite external groups to <a href='contact'>submit requests</a> for candidate enhancers to be tested.
            </p>
            <p>
            <StatisticsCounter />
            
          </p>
          
          </div>
          

      </Row>
        <div className="border mx-3" style={{fontSize:"18px", width:"100%"}}>
            If you use VISTA Enhancer Browser in your work please cite the following publications:
            <br/><br/>
            <p className="border rounded mx-2" style={{backgroundColor:"#E8E8E8"}}>
            Kosicki, M., Baltoumas, F.A., Kelman, G., Boverhof, J., Ong, Y., Cook, L.E., Dickel, D.E., Pavlopoulos, G.A., Pennacchio, L.A., Visel, A. (2024).
            <br/><b>VISTA Enhancer Browser: An updated database of tissue-specific developmental enhancers.</b>
            <br/><i>Nucleic Acids Res.</i> gkae940, PubMed: <a href='https://pubmed.ncbi.nlm.nih.gov/39470740/' target='_blank' rel='noreferrer'>39470740</a>
            </p>
            
            <p className="border rounded mx-2" style={{backgroundColor:"#E8E8E8"}}>
            Visel A, Minovitsky S, Dubchak I, Pennacchio LA (2007).
            <br/><b>VISTA Enhancer Browser - a database of tissue-specific human enhancers.</b>
            <br/><i>Nucleic Acids Res.</i> 35:D88-92, PubMed: <a href='https://pubmed.ncbi.nlm.nih.gov/17130149/' target='_blank' rel='noreferrer'>17130149</a>
            </p>
          </div>
          <br/>
          <div className="border mx-3" style={{fontSize:"18px", width:"100%"}}>
            <p style={{backgroundColor:"", fontSize:"18px"}}>
              <span className='pi pi-info-circle' style={{color:"red"}}> </span> <b>Note:</b> The legacy version of VISTA Enhancer Browser, which was discontinued in July 2024, can be found <a href='https://vista-enhancer.lbl.gov' target='_blank' rel='noreferrer'>here</a>.
            </p>
          </div>
    </Container>
    </main>
  );
}